import React from 'react'

export function CardValidIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{display: 'block', flexShrink: 0}}
    >
      <path
        d="M13.4889 5.75648L12.2341 4.49998V3.49781C12.2341 2.53473 11.4513 1.75073 10.4894 1.75073H9.48835L8.2336 0.494812C7.57385 -0.164937 6.42469 -0.164937 5.76552 0.494812L4.51077 1.75073H3.50977C2.54727 1.75073 1.76502 2.53415 1.76502 3.49781V4.49998L0.509687 5.75648C-0.169896 6.43781 -0.169896 7.54556 0.509687 8.2269L1.76444 9.4834V10.4856C1.76444 11.4486 2.54727 12.2326 3.50919 12.2326H4.51019L5.76494 13.4886C6.09452 13.8181 6.53319 14.0001 6.99927 14.0001C7.46535 14.0001 7.90344 13.8181 8.23302 13.4886L9.48777 12.2326H10.4888C11.4513 12.2326 12.2335 11.4492 12.2335 10.4856V9.4834L13.4889 8.2269C14.1684 7.54556 14.1684 6.43781 13.4889 5.75648ZM10.6177 5.95656L7.66952 8.87031C7.31135 9.22615 6.83944 9.40464 6.3681 9.40464C5.89677 9.40464 5.42719 9.22673 5.06785 8.87206L3.55177 7.41431C3.3231 7.1874 3.32077 6.81873 3.54769 6.58948C3.77519 6.3614 4.14327 6.35848 4.3731 6.5854L5.8886 8.04256C6.15285 8.30448 6.58277 8.30506 6.8476 8.04256L9.79635 5.12823C10.0262 4.90073 10.3949 4.90306 10.6218 5.13231C10.8487 5.36156 10.8464 5.72965 10.6177 5.95656Z"
        fill="#36A635"
      />
    </svg>
  )
}
